<template>
  <div class="ms-4">
    <!--    {{ errors }}-->
    <div class="form-check">
      <Field type="radio" :name="checkbox.field_names.standort">
        <input type="radio"
               :name="checkbox.field_names.standort"
               :id="`${group}_${model}_anderer_standort_nein`"
               value="false"
               class="form-check-input"
               v-model="surveyStore.data[group][model].anderer_standort"
        />
        <label class="form-check-label" :for="`${group}_${model}_anderer_standort_nein`">
          gleicher Standort wie "{{ surveyStore.data.objektname }}"
        </label>
      </Field>
    </div>
    <div class="form-check">
      <Field type="radio" :name="checkbox.field_names.standort" value="true">
        <input type="radio"
               :name="checkbox.field_names.standort"
               :id="`${group}_${model}_anderer_standort_ja`"
               class="form-check-input"
               v-model="surveyStore.data[group][model].anderer_standort"
               value="true"
        />
        <label class="form-check-label" :for="`${group}_${model}_anderer_standort_ja`">
          anderer Standort als "{{ surveyStore.data.objektname }}"
        </label>

        <div class="invalid-feedback">
          {{ errors[checkbox.field_names.standort] }}
        </div>
      </Field>
    </div>
    <div v-if="surveyStore.data[group][model].anderer_standort === 'true' ">
      Gehört dieses Objekt organisatorisch zu "{{ surveyStore.data.objektname }}"?
      <br>
      <div class="ms-3">
        <div class="form-check">
          <Field type="radio" :name="checkbox.field_names.andere_orga" value="false">
            <input type="radio" :name="checkbox.field_names.andere_orga" :id="`${group}_${model}_anderere_orga_nein`"
                   class="form-check-input"
                   v-model="surveyStore.data[group][model].andere_orga"
                   value="false"
            />
            <label class="form-check-label" :for="`${group}_${model}_anderere_orga_nein`">
              <b>ja</b>, das Objekt gehört organisatorisch zu {{ surveyStore.data.objektname }}.
              <br>Wir legen ein neues Objekt für Sie an. Sie können dann dort den Standort festlegen.
            </label>
          </Field>
        </div>
        <div clasS="form-check">
          <Field type="radio" :name="checkbox.field_names.andere_orga" value="true">
            <input type="radio" :name="checkbox.field_names.andere_orga" :id="`${group}_${model}_anderere_orga_ja`"
                   value="true"
                   :checked="surveyStore.data[group][model].andere_orga === 'true'"
                   class="form-check-input"
                   v-model="surveyStore.data[group][model].andere_orga"/>
            <label class="form-check-label" :for="`${group}_${model}_anderere_orga_ja`">
              <b>nein</b>, das Objekt gehört organisatorisch <b>nicht</b> zu {{ surveyStore.data.objektname }}.
              <br> Wir legen eine neue Organisation für Sie an. Sie können dann jederzeit zwischen den Organisationen
              wechseln.
            </label>
          </Field>
        </div>
        <div class="ms-4 mt-2">
          <Field type="text" :name="checkbox.field_names.orga_name"
                 v-if="surveyStore.data[group][model].andere_orga === 'true'">
            <label class="form-check-label" :for="`${group}_${model}_orga_name`">
              Bitte geben Sie für die neue Organisation einen Namen ein:
            </label>
            <input class="w-100" type="text"
                   v-model="surveyStore.data[group][model].orga_name"
                   :name="checkbox.field_names.andere_orga"
                   :id="`${group}_${model}_orga_name`">
          </Field>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "../../../stores/survey";
import {Field} from 'vee-validate';

export default {
  components: {
    Field,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {}
  },
  props: {
    model: String,
    group: String,
    checkbox: Object,
    errors: Object,
  },
  methods: {
    changeStandortRadio() {

    }
  },

}
</script>